import { useState, useCallback, useRef } from 'react';
import type { TeamMember } from '../components/about/TeamMemberDrawer.types';
import type { DrawerPhase } from './TeamDrawerContext.types';
import { TeamDrawerContext } from './teamDrawerContextValue';

export function TeamDrawerProvider({ children }: { children: React.ReactNode }) {
  const [phase, setPhase] = useState<DrawerPhase>('closed');
  const [selectedMember, setSelectedMember] = useState<TeamMember | null>(null);
  const savedScrollY = useRef(0);

  const openDrawer = useCallback((member: TeamMember) => {
    savedScrollY.current = window.scrollY;
    document.body.style.overflow = 'hidden';
    setSelectedMember(member);
    setPhase('opening');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setPhase('open');
      });
    });
  }, []);

  const closeDrawer = useCallback(() => {
    setPhase('closing');
    setTimeout(() => {
      setPhase('closed');
      setSelectedMember(null);
      document.body.style.overflow = '';
      window.scrollTo(0, savedScrollY.current);
    }, 500);
  }, []);

  return (
    <TeamDrawerContext.Provider value={{ phase, selectedMember, openDrawer, closeDrawer }}>
      {children}
    </TeamDrawerContext.Provider>
  );
}
